import { Component } from '@angular/core';

import { AuthenticationService } from './services/auth/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    class: 'flex flex-col w-full h-full',
  },
})
export class AppComponent {
  constructor(public auth: AuthenticationService) {
    if (auth.isLoggedIn) {
      auth.connectSockets();
    }
  }
}
